import cn from "classnames";

import css from "./letterLinksNav.module.css";

interface LetterLinksNavProps {
  title?: string;
  letterLinks: {
    text: string;
    link: string;
    title?: string;
  }[];
  containerClassName?: string;
}

const LetterLinksNav = (props: LetterLinksNavProps) => {
  const { title, letterLinks, containerClassName } = props;

  return (
    <div className={cn("d-flex gg-16 flex-wrap align-items-center", containerClassName)}>
      {title && (
        <span
          className={cn(css["brandon-grey"], "text-uppercase z-font-12 z-font-400")}
        >
          {title}
        </span>
      )}

      <ul className={cn(css.list, "list-unstyled ml-lg-auto mb-0 d-flex gg-12 flex-wrap")}>
        {!!letterLinks?.length && letterLinks.map((letterLink) => (
          <li
            key={`letter-link-${letterLink.text}`}
            className={cn(css["brandon-grey"], "line-height-1")}
          >
            <a
              href={letterLink.link}
              target="_self"
              title={letterLink.title || ''}
              className="text-capitalize alink z-font-12"
            >
              {letterLink.text}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LetterLinksNav;

